import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Umgebungswechsel der nativen App. Die Seite /mobile_app/env_change wird per Path-Configuration als
// Bottom Sheet geöffnet: Footer-Link (Admins) oder versteckt über mehrere Taps auf das Login-Logo.
// Die Buttons auf der Seite melden die neue Base-URL an die App ("updateBaseURL").
// Lädt nur, wenn die App die Komponente "base-url" meldet (BridgeComponent.shouldLoad).
//
// Connects to data-controller="native--base-url"
export default class extends BridgeComponent {
  static component = "base-url"
  static targets = ["customURLField", "customURLInput"]
  static values = {
    url: String,
    tapsRequired: { type: Number, default: 7 },
  }

  connect() {
    super.connect()
    this.tapCount = 0
  }

  disconnect() {
    clearTimeout(this.tapResetTimer)
    super.disconnect()
  }

  // Versteckter Trigger: mehrere Taps innerhalb von 3 s (Login-Logo) öffnen die Umgebungsseite
  secretTap() {
    clearTimeout(this.tapResetTimer)
    this.tapCount += 1

    if (this.tapCount >= this.tapsRequiredValue) {
      this.tapCount = 0
      window.Turbo.visit(this.urlValue)
    } else {
      this.tapResetTimer = setTimeout(() => (this.tapCount = 0), 3000)
    }
  }

  updateBaseURL({ params: { url } }) {
    this.send("updateBaseURL", { url })
  }

  showCustomURLField() {
    this.customURLFieldTarget.classList.remove("d-none")
    this.customURLInputTarget.focus()
    this.customURLInputTarget.select()
  }

  submitCustomURL(event) {
    event.preventDefault()

    const url = this.normalizedCustomURL
    if (!url) return

    this.updateBaseURL({ params: { url } })
  }

  get normalizedCustomURL() {
    const value = this.customURLInputTarget.value.trim().replace(/\/+$/, "")
    if (!value) return null

    return /^https?:\/\//.test(value) ? value : `http://${value}`
  }
}
